export enum ValidationState {
	Valid = 'is-valid',
	Invalid = 'is-invalid',
	Neutral = '',
}
